<div [dfs]="'p-a:2 p-t:20px flex-grow:1'"
     [ngSwitch]="loadStatus.busy">

    <ng-container *ngSwitchCase="false"
                  [ngSwitch]="!!config">

        <ng-form #form="ngForm"
                 *ngSwitchCase="true"
                 [dfs]="'p-a:2 d:block'">
            <icms-form-field [label]="field.title"
                             *ngFor="let field of fields">
                <textarea *ngIf="config.data?.content"
                          [name]="field.key"
                          [(ngModel)]="config.data!.content[field.key]"
                          [placeholder]="schemaExample"
                          [required]="isRequired(field, config.data!.content)"
                          style="height: 150px"></textarea>

                <icms-hint-banner *ngIf="field.description"
                                  [dfs]="'m-t:2 d:inline-block'"><span
                          [innerHTML]="field.description"></span></icms-hint-banner>
            </icms-form-field>
        </ng-form>

        <icms-hint-banner *ngSwitchCase="false">Custome schema data cannot be set for current page.</icms-hint-banner>
    </ng-container>

    <icms-skeleton-loader *ngSwitchCase="true"
                          [numberOfLines]="2"></icms-skeleton-loader>

</div>

<div [dfs]="'p-a:2 b-t:1px bc:15'"
     *ngIf="!loadStatus.busy && config">
    <button [iCmsButtonStyle]="'accent'"
            [status]="saveStatus"
            [dfs]="'w:100%'"
            (click)="save()">Save</button>
</div>
